export class File {
  name: string;
  type: string;
  size: number;
  data: any;
}
